import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import AnnouncementList from './list/list';

const AnnouncementModule = () => {
  return (
    <PageContentWrapper>
      <Routes>
        <Route path="/" element={<AnnouncementList />} />
      </Routes>
    </PageContentWrapper>
  );
};

export default AnnouncementModule;
